import React, { createContext, useContext } from "react";
import { useAppSelector } from "hooks/useAppSelector";
import { userSelector } from "reduxStore/auth/selectors";
import { useNotificationUnreadCounts } from "hooks/useNotificationUnreadCounts";

type NotificationUnreadContextValue = ReturnType<
  typeof useNotificationUnreadCounts
>;

const NotificationUnreadContext =
  createContext<NotificationUnreadContextValue | null>(null);

export function NotificationUnreadProvider({
  children,
  socketConnected,
}: {
  children: React.ReactNode;
  socketConnected: boolean;
}) {
  const user = useAppSelector(userSelector);
  const value = useNotificationUnreadCounts(user?.user_id, socketConnected);
  return (
    <NotificationUnreadContext.Provider value={value}>
      {children}
    </NotificationUnreadContext.Provider>
  );
}

export function useNotificationUnread(): NotificationUnreadContextValue {
  const ctx = useContext(NotificationUnreadContext);
  if (!ctx) {
    throw new Error(
      "useNotificationUnread must be used within NotificationUnreadProvider",
    );
  }
  return ctx;
}
